// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
   apiKey: "AIzaSyBBWTS2VU8ic8vyTQWMQAMq_NMPgti_0Co",
  authDomain: "primemax-278c2.firebaseapp.com",
  databaseURL: "https://primemax-278c2-default-rtdb.asia-southeast1.firebasedatabase.app/", // ✅ must include this
  projectId: "primemax-278c2",
  storageBucket: "primemax-278c2.firebasestorage.app",
  messagingSenderId: "423956914839",
  appId: "1:423956914839:web:072a13446d451f409a7fd2",
  measurementId: "G-R20TRZRG2E",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const db = getDatabase(app);
export const auth = getAuth(app);
export const storage = getStorage(app);